export enum TimezoneEnum {
  AKDT = 'Alaska Daylight Time',
  AKST = 'Alaska Standard Time',
  AST = 'Atlantic Standard Time',
  CST = 'Central Standard Time',
  CDT = 'Central Daylight Time',
  EDT = 'Eastern Daylight Time',
  EST = 'Eastern Standard Time',
  HDT = 'Hawaii-Aleutian Daylight Time',
  HST = 'Hawaii Standard Time',
  MDT = 'Mountain Daylight Time',
  MST = 'Mountain Standard Time',
  PDT = 'Pacific Daylight Time',
  PST = 'Pacific Standard Time',
}
